import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const issueNavigatorProjectSoftwareRoute: InvariantJiraRoute = {
	name: 'software-issue-navigator',
	path: '/jira/software/projects/:projectKey/issues/:issueKey?',
};
